// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router","783": "lib-react",}[chunkId] || chunkId) + "." + {"122": "21a578a4","258": "381467cf","27": "8ebf6e76","354": "784d17f9","48": "b5715888","535": "c683365a","783": "e5539cf7",}[chunkId] + ".js"
}